import { PropsWithChildren } from 'react';
import { HorizontalGridLines, VerticalBarSeries, XAxis, XYPlot, YAxis } from 'react-vis';
import { useTheme } from 'styled-components';

function Label(props: PropsWithChildren<{ width: number }>) {
	return <text transform="rotate(45) translate(0, 20)">{props.children}</text>;
}

function Level(props: PropsWithChildren<{ width: number; selected?: boolean }>) {
	const theme = useTheme() as any;

	return (
		<text
			style={{
				fontSize: 17,
				fontWeight: props.selected ? 'bold' : 'normal',
				fill: props.selected ? theme.colors.manager : theme.colors.slateBlue,
			}}
			dy="0.32em"
			textAnchor="end"
			transform="translate(-14, 0)"
		>
			{props.children}
		</text>
	);
}

export default function EvaluationSubmissionGraph(props: {
	levels: string[];
	match?: number;
	sections: {
		name: string;
		score?: number;
	}[];
}) {
	const theme = useTheme() as any;

	return (
		<XYPlot
			width={700}
			height={400}
			xDomain={[-1, props.sections.length]}
			yDomain={[-1, props.levels.length]}
			margin={{
				left: 300,
				bottom: 150,
			}}
		>
			<HorizontalGridLines
				tickValues={props.levels.map((_, index) => index)}
				style={{
					stroke: theme.colors.slateBlue,
					strokeDasharray: '1 2',
				}}
			/>
			<HorizontalGridLines
				tickValues={[-1, props.levels.length]}
				style={{
					stroke: theme.colors.slateBlue,
					strokeWidth: 2,
				}}
			/>
			{props.match !== undefined && (
				<HorizontalGridLines
					tickValues={[props.match]}
					style={{
						stroke: theme.colors.manager,
						strokeWidth: 2,
					}}
				/>
			)}
			<VerticalBarSeries
				barWidth={0.8}
				color={theme.colors.manager}
				data={props.sections.map(({ score }, index) => ({
					x: index,
					y: score !== undefined ? score * (props.levels.length - 1) : -1,
				}))}
			/>
			<XAxis
				tickFormat={(index) => (<Label width={100}>{props.sections[index].name}</Label>) as any}
				tickValues={props.sections.map((_, index) => index)}
				style={{
					fill: theme.colors.slateBlue,
				}}
			/>
			<YAxis
				tickFormat={(index) =>
					(
						<Level width={100} selected={index === props.match}>
							{props.levels[index]}
						</Level>
					) as any
				}
				tickValues={props.levels.map((_, index) => index)}
			/>
		</XYPlot>
	);
}
